import React, { useEffect, useState } from "react";
import { Membership } from "../../models";
import BasicSelect, {formattedOption} from "../Select/BasicSelect";

interface _Props {
    menuPlacement?: (string | null)
    selectedValue?: (string | null)
    memberships?: (Membership[] | null)
    onSelect: Function
}

const SelectMembershipByBackNumber: React.FC<_Props> = ({selectedValue, memberships, menuPlacement, onSelect}) => {

    const [selected, setSelected] = useState<string | null | undefined>();
    const [formattedMemberships, setFormattedMemberships] = useState<formattedOption[] | null | undefined>();

    const formatMemberships = (memberships: Membership[]) => {
        let formattedMemberships = [];
        for (var i = 0; i < memberships.length; i++) {
            const value = memberships[i].id;
            const label = (memberships[i].backNumber || "") + (memberships[i].personName ? " - " + memberships[i].personName : "") + (memberships[i].horse?.name ? " - " + memberships[i].horse?.name : "");
            let object: formattedOption = {
                value: value,
                label: label,
                object: memberships[i]
            };
            formattedMemberships.push(object);
        }
        setFormattedMemberships(formattedMemberships);
    }

    useEffect(() => {
        if (memberships) formatMemberships(memberships);
    }, [memberships]);

    useEffect(() => {
        if (selectedValue) setSelected(selectedValue);
        else setSelected(undefined);
    }, [selectedValue]);

    const handleOnChange = (event?: any) => {
        if (event) {
            onSelect(event);
        } else {
            onSelect();
        }
    }

    return (
        <>
            {formattedMemberships ?
                <BasicSelect formattedValues={formattedMemberships} menuPlacement={menuPlacement} selectedValue={selected} onSelect={handleOnChange} />
                :
                <p>Loading options...</p>
            }
        </>
    )
};

export default SelectMembershipByBackNumber;
